module.exports = __webpack_public_path__ + "img/issue-icon-dark.fe0e0593.svg";